import {
    WorkbenchPlugin,
    WorkbenchPluginId, WorkbenchViewKind
} from '../../shared/types';
import {ComponentRef, Injectable} from '@angular/core';
import {Observable, of} from "rxjs";
import {WorkbenchCommandRegistry} from "../../shared/services/workbench-command-registry.service";
import {WorkbenchLayoutManager} from "../../shared/services/workbench-layout-manager.service";
import {testInfo} from '@webmate-web-core/shared/icons';
import {WorkbenchAdhocTestViewComponent} from './views/workbench-adhoc-test-view.component';
import {FindingId} from '@webmate-web-core/shared/types/ids';

@Injectable()
export class TestMgmtPlugin extends WorkbenchPlugin {
    id: WorkbenchPluginId = 'testmgmt';
    views: WorkbenchViewKind[];

    static readonly AdhocTestViewId = 'testmgmt.view.adhoctest';
    static readonly AddFindingsViewId = 'testmgmt.view.addFindings';

    private viewContainerId = 'testmgmt.viewcontainer';

    constructor(private commandRegistry: WorkbenchCommandRegistry,
                readonly layoutManager: WorkbenchLayoutManager) {
        super(layoutManager);
        this.views = [
            {
                id: TestMgmtPlugin.AdhocTestViewId,
                component: WorkbenchAdhocTestViewComponent,
                name: 'Test',
                defaultViewContainer: this.viewContainerId,
                expandedByDefault: true,
                visibility: 'manual-test',
            },
            // {
            //     id: TestMgmtPlugin.AddFindingsViewId,
            //     component: AddFindingsViewComponent,
            //     name: 'Findings',
            //     defaultViewContainer: this.viewContainerId,
            //     expandedByDefault: true
            // }
        ];

    }

    onWorkbenchDestroy(): void {
    }

    onWorkbenchInit(): Observable<void> {
        this.layoutManager.registerViewContainer({
            type: 'NormalViewContainer',
            id: this.viewContainerId,
            name: 'Manual Tests',
            icon: {
                type: 'svg',
                path: '../../assets/img/tests.svg',
            },
            allowedPanels: ['left-top', 'left-bottom'],
            defaultPanel: 'left-top',
            displayMode: 'standalone',
            toolbarCommandId: 'testmgmt:toggleViewContainer'
        });

        //Commands
        this.commandRegistry.registerCommand(
            'testmgmt:openViewContainerWithFinding',
            {},
            (params: {findingId: FindingId}) => {
                this.layoutManager.showViewContainer(this.viewContainerId);
                (this.layoutManager.getViewState(TestMgmtPlugin.AdhocTestViewId).viewComponentRef as ComponentRef<WorkbenchAdhocTestViewComponent>).instance.openFinding(params.findingId);
            }
        );

        this.commandRegistry.registerCommand(
            'testmgmt:toggleViewContainer',
            {
                name: 'Test Info',
                icon: {
                    type: 'faIcon',
                    instance: testInfo,
                },
                description: 'Show Test',
                visibility: 'manual-test',
                statusBindings: {
                    'active': {
                        'type': 'store',
                        'storeKey': `viewcontainers.${this.viewContainerId}.status.visible`,
                    }
                }
            },
            () => {
                this.layoutManager.toggleViewContainer(this.viewContainerId, true);
            }
        )

        return of(undefined);
    }

}
